import { type DirectorAddressStore } from "services/director/directorAddressStore";
import { type DirectorStore } from "services/director/directorStore";
import { IssueKey, type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { DirectorQuestion, ISSUE_FIELD_TO_QUESTION } from "./directorConstants";

export class DirectorQuestionsStore extends QuestionsStore<DirectorQuestion> {
  protected _issueKey = IssueKey.Director;
  protected _issueFieldsToQuestions = ISSUE_FIELD_TO_QUESTION;

  constructor(
    private readonly _directorStore: DirectorStore,
    private readonly _directorAddressStore: DirectorAddressStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(DirectorQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): DirectorQuestion | undefined {
    const { mainDirector } = this._directorStore;

    if (!mainDirector?.firstName || !mainDirector?.lastName) {
      return DirectorQuestion.Name;
    }

    if (!mainDirector.dob) {
      return DirectorQuestion.Birthday;
    }

    if (!mainDirector.nationality) {
      return DirectorQuestion.Nationality;
    }

    const address = this._directorAddressStore.tryGetForDirector(mainDirector.id);
    if (!address) {
      return DirectorQuestion.Address;
    }

    return undefined;
  }

  protected _shouldSkipQuestion(question: DirectorQuestion): boolean {
    switch (question) {
      case DirectorQuestion.PreviousAddress:
        return !this._directorAddressStore.getisCurrentAddressLessThanOneYear(this._directorStore.getMainDirector().id);
    }

    return super._shouldSkipQuestion(question);
  }
}
